<div class="draft-warning">
  <div class="draft-warning__title">
    <h2>{{ 'NEW_CONTRACTS.DRAFT_DIALOG.TITLE' | i18nextEager }}</h2>
    <span class="draft-warning__title__close" (click)="closeDialog()">
      <img src="/assets/icons/close_modal.svg" alt="" />
    </span>
  </div>
  <span class="text">{{ 'NEW_CONTRACTS.DRAFT_DIALOG.TEXT' | i18nextEager }}</span>
  <img src="/assets/images/road.svg" alt="" />
  <div class="buttons">
    <button class="secondary" (click)="closeDialog()">{{ 'COMMONS.DONT_SAVE' | i18nextEager }}</button>
    <button>{{ 'COMMONS.SAVE' | i18nextEager }}</button>
  </div>
</div>
